// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._8211f8+._8211f8{margin-top:var(--spacer)}.e84671{margin:.5rem 0 -0.5rem 1.65rem;padding:1rem 0 0 1.65rem;position:relative;font-size:.9em}.e84671._30f2a2{font-size:.75em}.e84671:before{content:\"\";position:absolute;top:0;left:0;width:1px;transform:rotate(180deg);bottom:0;background:linear-gradient(transparent, var(--subtle) 1em)}li:last-child>.e84671{margin-bottom:1.5rem}.dede83{position:relative}.dede83:before{content:\"\";position:absolute;top:1.75em;left:-1.65rem;display:block;width:1.65rem;border-bottom:1px solid var(--subtle)}", ""]);
// Exports
exports.locals = {
	"item": "_8211f8",
	"sub": "e84671",
	"small": "_30f2a2",
	"subLine": "dede83"
};
module.exports = exports;
